import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
//import apiService from '../services/apiservices'


//import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/menu_disabled_ticketsTable.css'

import * as Helpers from '../../../common/helpers'



class CollapsibleProductsRow extends Component {
    constructor() {
        super()
        this.state = {
        }
        this.dialog = null
    }

    componentWillMount() {
       
    }

   


    

    

    render() {
        const options = {
            page: 1,  // which page you want to show as default
            sizePerPage: 10,  // which size per page you want to locate as default
        }
        return (
            <div style={{ backgroundColor: "#e1e5ed",margin: "0% 4%" }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    className="table-border"
                    options={options}
                    data={this.props.row.menu_ticket_details}
                    hover={false}
                    headerStyle={{ border: '0px', color: '#000' }}
                    tableStyle={{ border: '0px' }}
                    bodyStyle={{ border: '0px', overflow: "auto" }}>

                     {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}
                   

                    <TableHeaderColumn
                        dataField="sku"
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        SKU
                    </TableHeaderColumn> 

                    <TableHeaderColumn
                        dataField="product"
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Name
                    </TableHeaderColumn> 


                    <TableHeaderColumn
                        dataField="reason"
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Reason
                    </TableHeaderColumn> 

                    <TableHeaderColumn
                        dataField="remarks"
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Remarks
                    </TableHeaderColumn>                              
                
                </BootstrapTable>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        stores: state.stores,
        user: state.user
    }
}

export default connect(mapStateToProps)(withRouter(CollapsibleProductsRow))


// WEBPACK FOOTER //
// ./src/modules/Menu Disabled Tickets/Components/CollapsibleProductsRow.js